import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyCMKaMPQthH2xEILyEX6aEVRcbzShoReRo",
    authDomain: "aiprompts-947a6.firebaseapp.com",
    projectId: "aiprompts-947a6",
    storageBucket: "aiprompts-947a6.firebasestorage.app",
    messagingSenderId: "306947882627",
    appId: "1:306947882627:web:00284257dfca628445a5b6",
    measurementId: "G-CDDG22G50L"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app)
const functions = getFunctions(app);

export {db, auth, functions };
//export const storage = getStorage(app)